<template>
    <section class="d-flex flex-column align-items-center justify-content-center py-5 position-relative min-h-40 min-vh-md-100 bg-cover text-white">
        <div class="position-absolute inset-0 overflow-hidden feature-video" style="z-index: 0;">
            <video class="absolute inset-0 w-100 h-100 object-cover" autoplay="" muted="" loop="">
                <source src="@/assets/video/6v6-landing-hero.mp4" type="video/mp4">
                <!-- <source src="https://6v6foot.com/newInterfaceTemplate/VID-20250509-WA0001.mp4" type="video/mp4"> -->
                Your browser does not support the video tag.
            </video>
        </div>
        <header class="d-flex flex-column align-items-center p-5" style="z-index: 5; width: fit-content;">
            <h1 class="font-weight-bold text-primary display-1">
                6v6 <span class="text-white">foot</span>
            </h1>
            <div class="d-flex flex-wrap mb-1 align-items-center">
                <h3 class="font-weight-500 text-white text-center py-2">Pour faire de votre match un moment inoubliable.</h3>
            </div>
            <div class="d-flex flex-wrap mt-2 justify-content-start justify-content-lg-center">
                <a class="btn btn-primary py-2 px-5 rounded-pill w-auto text-dark h6" href="/search">
                    <b>Réserver un match</b>
                </a>
            </div>
        </header>
    </section>
</template>